import { InvisibleIcon, VisibleIcon } from '@bp/ui-components';
import React from 'react';

export const EyeSymbol = ({ visible, toggle }: { visible: boolean; toggle: () => void }) => {
  if (visible) return <InvisibleIcon onClick={toggle} />;

  return <VisibleIcon onClick={toggle} />;
};
